exports = module.exports = require("./../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dialog-view{padding:10px}.inside-form{margin:5px 0}.inside-form-item{display:inline-block}.inside-form-item__input{box-sizing:border-box;height:30px;padding:5px;width:60%}.inside-form-item__btn{vertical-align:top;box-sizing:border-box;height:30px;line-height:30px}", "", {"version":3,"sources":["/./src/views/dialogView.vue"],"names":[],"mappings":"AACA,aAAa,YAAY,CACxB,AACD,aAAa,YAAY,CACxB,AACD,kBAAkB,oBAAoB,CACrC,AACD,yBAAyB,sBAAsB,YAAY,YAAY,SAAS,CAC/E,AACD,uBAAuB,mBAAmB,sBAAsB,YAAY,gBAAgB,CAC3F","file":"dialogView.vue","sourcesContent":["\n.dialog-view{padding:10px\n}\n.inside-form{margin:5px 0\n}\n.inside-form-item{display:inline-block\n}\n.inside-form-item__input{box-sizing:border-box;height:30px;padding:5px;width:60%\n}\n.inside-form-item__btn{vertical-align:top;box-sizing:border-box;height:30px;line-height:30px\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-c521d72e!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/views/dialogView.vue
// module id = 106
// module chunks = 0